export default  {
  count (state) {
    return state.count
  },
  list (state) {
    return state.list
  },
  relation (state) {
    return state.relation
  },
  maincontact (state){
    if (!state.relation.contacts || state.relation.contacts.length==0) return {}
    var contact = state.relation.contacts[0]
    state.relation.contacts.forEach(function(c){
      contact = c
      if (c.main) return  c
    })
    return contact
  },
  contacts (state) {
    return state.contacts
  },
   item: state => index => state.list.filter(e => e._id === index)[0]
}